export { default as ReadMoreDS } from './read-more-ds'
export type { ReadMoreDSProps } from './read-more-ds'
